import { Box, Button, Icon, Text, VStack } from '@chakra-ui/react';
import { FaUserSlash, FaFilePdf, FaFileImage, FaFileVideo, FaHeadphones } from 'react-icons/fa';

export default function NoDataMessage({title, desc, buttonText, onClick, filterType, disabled=false}) {
    const icons = {
        "pdfs": FaFilePdf,
        "audios": FaHeadphones,
        "videos": FaFileVideo,
        "images": FaFileImage,
        "staffs": FaUserSlash
    }
  return (
    <Box
      height="calc(100% - 85px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
    >
      <VStack spacing={3} textAlign="center">
        <Icon as={icons[filterType]} w={12} h={12} color="gray.400" />
        <Text fontSize="lg" fontWeight="semibold" color="gray.700">
          {title}
        </Text>
        <Text fontSize="md" color="gray.500">
        {desc}
        </Text>
        <Button colorScheme="blue" size="md" onClick={onClick} disabled={disabled}>
          {buttonText}
        </Button>
      </VStack>
    </Box>
  );
}
